// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"J5-z","inlineTitle":"K5-z","sponsoredAdsWrapper":"L5-z","marketplaceRecosWrapper":"M5-z","brandShopTheLookWrapper":"N5-z"};